import React, { useState, useEffect } from 'react';
import './App.css';
import { getApiUrl } from './apiConfig';

const styles = `
  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .center-section {
    animation: slideInUp 0.6s ease-out forwards;
  }
  
  .center-card {
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid #e5e7eb;
  }
  
  .center-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px -10px rgba(11, 107, 47, 0.3);
    border-color: #0b6b2f;
  }

  .subcenter-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #fff;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    transition: all 0.2s;
  }

  .subcenter-link:hover {
    background: #f0fdf4;
  }

  .icon-box {
    width: 40px;
    height: 40px;
    background: #ecfdf5;
    color: #0b6b2f;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const defaultCenters = [
  {
    id: 1,
    name: 'නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - රත්නපුර',
    slug: 'rathnpura-deputy',
    phone: '045-2222505',
    email: 'agrirathnapura@gmail.com',
    subCenters: [
      { id: 101, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - මුවවගම, රත්නපුර', slug: 'rathnpura-assistant', phone: '045-2222238' },
      { id: 102, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - නිවිතිගල', slug: 'rathnpura-nivithigala', phone: '045-2279238' },
      { id: 103, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - බලංගොඩ', slug: 'rathnpura-balangoda', phone: '045-2287238' },
      { id: 104, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - ඇඹිළිපිටිය', slug: 'rathnpura-embilipitiya', phone: '047-2230238' },
      { id: 105, name: 'සේවා සංස්කරණ අභ්‍යාස ආයතනය - රජවක', slug: 'service-center', phone: '045-2285238' },
      { id: 106, name: 'දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය - කරපිංච', slug: 'rathnpura-karapincha', phone: '045-2262238' },
      { id: 107, name: 'කෘෂි ව්‍යවසායකත්ව කේන්ද්‍රය - ඇඹිළිපිටිය', slug: 'rathnpura-tranee-embilipitiya', phone: '047-2261238' }
    ]
  },
  {
    id: 2,
    name: 'නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - කෑගල්ල',
    slug: 'kegalla-deputy',
    phone: '035-2222505',
    email: 'agrikegalle@gmail.com',
    subCenters: [
      { id: 201, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - කෑගල්ල', slug: 'kegalla-assistant', phone: '035-2222238' },
      { id: 202, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - රුවන්වැල්ල', slug: 'kegalla-ruwanwella', phone: '036-2266238' },
      { id: 203, name: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය - මාවනැල්ල', slug: 'kegalla-mawanella', phone: '035-2246238' },
      { id: 204, name: 'දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය - වාගොල්ල', slug: 'TraneeWagolla', phone: '035-2247238' },
      { id: 205, name: 'රජයේ මධ්‍යම පැල තවාන - බැමිණිවත්ත', slug: 'CentralPlants', phone: '035-2248238' },
      { id: 206, name: 'රජයේ ගොවිපල - මාරුක්වතුර', slug: 'Marukwathura', phone: '035-2249238' },
      { id: 207, name: 'බිම්මල් බීජ මධ්‍යස්ථානය - වාගොල්ල', slug: 'Bimmal', phone: '035-2250238' },
      { id: 208, name: 'පාංශු රසායනාගාරය - වාගොල්ල, රඹුක්කන', slug: 'Panshu', phone: '035-2251238' },
      { id: 209, name: 'පටක රෝපණ විද්‍යාගාරය - වාගොල්ල, රඹුක්කන', slug: 'PatakaRopana', phone: '035-2252238' }
    ]
  },
  {
    id: 3,
    name: 'තිරසර කෘෂිකර්ම ව්‍යාපෘතිය - කුට්ටිගල, පදලංගල',
    slug: 'tirasara-pro',
    phone: '047-2233238',
    email: 'tirasara.agri@gmail.com',
    subCenters: []
  }
];

export default function Centers({ onBackClick }) {
  const [centers, setCenters] = useState(defaultCenters);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const url = getApiUrl(`api_centers.php?t=${Date.now()}`);
        const res = await fetch(url);
        if (!res.ok) throw new Error('API Error');
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          setCenters(data);
        }
      } catch (err) {
        console.warn('Fetch centers warning, using fallback/local:', err);
        const local = localStorage.getItem('site_centers');
        if (local) {
          try {
            const parsed = JSON.parse(local);
            if (Array.isArray(parsed) && parsed.length > 0) setCenters(parsed);
          } catch (e) { }
        }
      }
    };
    fetchCenters();
  }, []);

  const handleBack = () => {
    if (onBackClick) {
      onBackClick('home');
    }
  };

  return (
    <main className="page-content centers-overview" style={{ padding: '40px 20px', paddingBottom: '120px', maxWidth: 1000, margin: '0 auto' }}>
      <style>{styles}</style>

      <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '30px' }}>
        <button
          onClick={handleBack}
          style={{
            backgroundColor: '#0b6b2f',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(11, 107, 47, 0.2)'
          }}
        >
          ← ආපසු
        </button>
        <h1 style={{ color: '#0b6b2f', fontSize: '32px', margin: 0, fontWeight: '800' }}>ආයතන හා මධ්‍යස්ථාන</h1>
      </div>

      <hr className="footer-sep" style={{ marginBottom: '40px', opacity: 0.3 }} />

      <div className="centers-list">
        {centers.map((center, idx) => (
          <section key={center.slug || idx} className="center-section" style={{ marginBottom: '50px', animationDelay: `${idx * 0.1}s` }}>
            <div
              onClick={() => onBackClick && onBackClick(center.slug)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 24px',
                backgroundColor: '#fff',
                borderRadius: '16px',
                border: '2px solid #0b6b2f',
                cursor: 'pointer',
                marginBottom: '24px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0fdf4';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <span style={{ fontSize: '24px' }}>🏢</span>
                <div>
                  <h2 style={{ fontSize: '20px', margin: 0, color: '#111', fontWeight: '700' }}>{center.name}</h2>
                  {(center.phone || center.email) && (
                    <div style={{ display: 'flex', gap: '12px', fontSize: '0.85rem', color: '#666', marginTop: '4px' }}>
                      {center.phone && <span>📞 {center.phone}</span>}
                      {center.email && <span>✉️ {center.email}</span>}
                    </div>
                  )}
                </div>
              </div>
              <span style={{ color: '#0b6b2f', fontWeight: 'bold', fontSize: '20px' }}>→</span>
            </div>

            {center.subCenters && center.subCenters.length > 0 && (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '16px',
                paddingLeft: '20px'
              }}>
                {center.subCenters.map(sub => (
                  <div
                    key={sub.slug || sub.id}
                    className="subcenter-link center-card"
                    onClick={() => onBackClick && onBackClick(sub.slug)}
                  >
                    <div className="icon-box">📍</div>
                    <div>
                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#444', display: 'block' }}>{sub.name}</span>
                      {sub.phone && <small style={{ color: '#888', fontSize: '0.8rem' }}>📞 {sub.phone}</small>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        ))}
      </div>
    </main>
  );
}
